import React from "react";

import { Icon, IconProps } from "../";

export const MccmDuoNotebookOpenIcon = (props: Omit<IconProps, "fill">) => {
  return (
    <Icon {...props}>
      <path
        d="M12.5991 6.38801V18.0709C15.0262 17.4346 18.3441 17.4242 20.7712 18.05V6.37758C19.7471 6.06464 18.3339 5.75171 16.6954 5.75171C15.0569 5.75171 13.5925 6.07507 12.5991 6.38801Z"
        fill="white"
      />
      <path
        d="M3.229 6.37758V18.05C5.63556 17.4242 8.94329 17.4346 11.3703 18.05V6.37758C10.3667 6.06464 8.96377 5.75171 7.31503 5.75171C5.66628 5.75171 4.23259 6.06464 3.229 6.37758Z"
        fill="#F7EE4D"
      />
      <path
        d="M21.5189 5.31363C20.434 4.94854 18.7247 4.5 16.6878 4.5C14.651 4.5 13.1157 4.89638 12 5.26147C10.915 4.90682 9.26714 4.5 7.31218 4.5C5.35722 4.5 3.54555 4.93811 2.42989 5.32406C2.174 5.40751 2 5.64743 2 5.91864V18.8741C2 19.2914 2.47083 19.6043 2.85977 19.4687C5.31627 18.6342 9.29785 18.6342 11.7543 19.4687C11.8158 19.4896 11.9284 19.5 12 19.5C12.0409 19.5 12.0716 19.4896 12.1024 19.4791C12.1535 19.4791 12.1945 19.4791 12.2457 19.4687C14.7021 18.6342 18.6837 18.6342 21.1402 19.4687C21.2016 19.4896 21.3142 19.5 21.3859 19.5C21.7236 19.5 22 19.2184 22 18.8741V5.91864C22 5.64743 21.7851 5.39708 21.5292 5.31363H21.5189ZM20.7615 18.0501C18.3357 17.4138 15.0194 17.4346 12.5937 18.0709V6.38804C13.5865 6.0751 15.0092 5.75174 16.6878 5.75174C18.3664 5.75174 19.7277 6.06467 20.7615 6.37761V18.0501ZM11.3654 18.0605C8.93961 17.4346 5.64381 17.4242 3.22825 18.0605V6.37761C4.22109 6.06467 5.65404 5.75174 7.31218 5.75174C8.97032 5.75174 10.3623 6.06467 11.3654 6.37761V18.0605Z"
        fill="#333333"
      />
    </Icon>
  );
};
